module.exports = __webpack_public_path__ + "img/jj.83f952f3.png";